import { CONTA_LOCAL } from './protocolo.js';
export const TABELAS_DA_BASE_DO_RELATORIO = [
    'perfil',
    'sessao',
    'visita',
    'estudo',
    'mes',
];
const tabelasNecessarias = new Set(TABELAS_DA_BASE_DO_RELATORIO);
const VERSAO_DA_BASE = '1';
function chave(dono) {
    return `base-relatorio-completa:${dono}`;
}
/**
 * A conta local nunca depende de pull: exigir marcador dela faria o app
 * offline por definição parecer incompleto para sempre.
 */
export async function baseDoRelatorioCompleta(banco, dono) {
    if (dono === CONTA_LOCAL)
        return true;
    return (await banco.estado.get(chave(dono)))?.valor === VERSAO_DA_BASE;
}
export async function marcarBaseDoRelatorioCompleta(banco, dono) {
    if (dono === CONTA_LOCAL)
        return;
    await banco.estado.put({ chave: chave(dono), valor: VERSAO_DA_BASE });
}
export async function invalidarBaseDoRelatorio(banco, dono) {
    if (dono === CONTA_LOCAL)
        return;
    await banco.estado.delete(chave(dono));
}
/** Linha remota inválida deixou um buraco mesmo que o cursor tenha avançado. */
export async function haLeituraMortaDoRelatorio(banco, dono) {
    return ((await banco.dead_letter
        .where('user_id')
        .equals(dono)
        .filter((morta) => morta.origem === 'pull' && tabelasNecessarias.has(morta.tabela))
        .count()) > 0);
}
export function tabelaPertenceABaseDoRelatorio(tabela) {
    return tabelasNecessarias.has(tabela);
}
//# sourceMappingURL=integridadeDoRelatorio.js.map